export type ExcelHeaderFieldKey =
    | 'family'
    | 'subFamily'
    | 'billingMode'
    | 'frequency'
    | 'codeElis'
    | 'label'
    | 'quantity'
    | 'appliedPrice'
    | 'consoCodeElis'
    | 'consoLabel'
    | 'consoQuantity'
    | 'consoAppliedPrice'
    | 'exchangeRule'
    | 'numberOfChange'
    | 'shape'
    | 'diameter'
    | 'width'
    | 'height'
    | 'initialStockSOL';

export interface ExcelHeaderProfile {
    translationKeys: string[];
    fields: ExcelHeaderFieldKey[];
}

const BASE_TRANSLATION_KEYS = [
    'SYNTHESIS.LABEL_CATEGORY',
    'SYNTHESIS.LABEL_SUB_FAMILY',
    'LABEL_BILLING_MODE',
    'LABEL_FREQUENCY',
    'SYNTHESIS.LABEL_CODE_ARTICLE',
    'SYNTHESIS.LABEL_SAS_LIBELLE_ARTICLE',
] as const;

const WEEKLY_MONTHLY_TRANSLATION_KEYS = ['LABEL_TOTAL_HEBDO_HT', 'LABEL_TOTAL_MENS_HT'] as const;

const WEEKLY_MONTHLY_TOTAL_COLUMNS = 2;

const createProfile = (
    translationKeys: string[],
    fields: ExcelHeaderFieldKey[],
): ExcelHeaderProfile => {
    const expectedTranslationKeysLength = fields.length + WEEKLY_MONTHLY_TOTAL_COLUMNS;
    if (translationKeys.length !== expectedTranslationKeysLength) {
        throw new Error(
            `Invalid Excel header profile: translationKeys length must be ${expectedTranslationKeysLength}, got ${translationKeys.length}`,
        );
    }

    return {
        translationKeys,
        fields,
    };
};

export const CONSO_PROFILE: ExcelHeaderProfile = createProfile(
    [
        ...BASE_TRANSLATION_KEYS,
        'SYNTHESIS.LABEL_SAS_QUANTITY',
        'LABEL_UNITARY_PRICE_ARTICLE_HT',
        'SYNTHESIS.LABEL_CODE_CONSUMABLE',
        'SYNTHESIS.LABEL_LIBELLE_CONSUMABLE',
        'LABEL_CONSUMMABLE_QUANTITY',
        'LABEL_UNITARY_PRICE_CONSUMABLE_HT',
        ...WEEKLY_MONTHLY_TRANSLATION_KEYS,
    ],
    [
        'family',
        'subFamily',
        'billingMode',
        'frequency',
        'codeElis',
        'label',
        'quantity',
        'appliedPrice',
        'consoCodeElis',
        'consoLabel',
        'consoQuantity',
        'consoAppliedPrice',
    ],
);

export const DASRI_PROFILE: ExcelHeaderProfile = createProfile(
    [
        ...BASE_TRANSLATION_KEYS,
        'LABEL_REAL_QTY',
        'LABEL_UNITARY_PRICE_ARTICLE_HT',
        ...WEEKLY_MONTHLY_TRANSLATION_KEYS,
    ],
    [
        'family',
        'subFamily',
        'billingMode',
        'frequency',
        'codeElis',
        'label',
        'quantity',
        'appliedPrice',
    ],
);

export const LS_PROFILE: ExcelHeaderProfile = createProfile(
    [
        ...BASE_TRANSLATION_KEYS,
        'SYNTHESIS.LABEL_LS_QUANTITY',
        'SYNTHESIS.LABEL_LS_PU_HT',
        'SYNTHESIS.LABEL_LS_EXCHANGE_RULE',
        ...WEEKLY_MONTHLY_TRANSLATION_KEYS,
    ],
    [
        'family',
        'subFamily',
        'billingMode',
        'frequency',
        'codeElis',
        'label',
        'quantity',
        'appliedPrice',
        'exchangeRule',
    ],
);

export const VT_PROFILE: ExcelHeaderProfile = createProfile(
    [
        ...BASE_TRANSLATION_KEYS,
        'SYNTHESIS.QUANTITY_PER_WEARER',
        'LABEL_UNITARY_PRICE_ARTICLE_HT',
        'LABEL_NUMBER_OF_CHANGE',
        ...WEEKLY_MONTHLY_TRANSLATION_KEYS,
    ],
    [
        'family',
        'subFamily',
        'billingMode',
        'frequency',
        'codeElis',
        'label',
        'quantity',
        'appliedPrice',
        'numberOfChange',
    ],
);

export const SOL_PROFILE: ExcelHeaderProfile = createProfile(
    [
        ...BASE_TRANSLATION_KEYS,
        'LABEL_SHAPE',
        'LABEL_DIAMETER',
        'LABEL_WIDTH',
        'LABEL_HEIGHT',
        'SYNTHESIS.LABEL_NBRE',
        'SYNTHESIS.LABEL_INITIAL_STOCK_TAPIS_PERSO',
        'LABEL_UNITARY_PRICE_ARTICLE_HT',
        ...WEEKLY_MONTHLY_TRANSLATION_KEYS,
    ],
    [
        'family',
        'subFamily',
        'billingMode',
        'frequency',
        'codeElis',
        'label',
        'shape',
        'diameter',
        'width',
        'height',
        'quantity',
        'initialStockSOL',
        'appliedPrice',
    ],
);

export const DEFAULT_EXCEL_PROFILE: ExcelHeaderProfile = CONSO_PROFILE;